export default __webpack_public_path__ + "static/media/Deo-Fame.ccc48cc1.jpg";